import {
  FundBasketLinkedSip,
  FundBasketLinkedSipCartStatus,
  FundBasketLinkedSipChanges,
  FundBasketRebalanceRequest,
  FundBasketRebalanceResponse,
  FundBasketVersion,
} from "../../types";
import { api } from "../axios";

export function getFundBasketLinkedSips(
  basketId: number
): Promise<FundBasketLinkedSip[]> {
  return api.get(`fund-baskets/${basketId}/linked-sips/`);
}

export function getFundBasketLinkedSipChanges(payload: {
  basketId: number;
  clientId: number;
}): Promise<FundBasketLinkedSipChanges[]> {
  return api.get(
    `fund-baskets/${payload.basketId}/linked-sips/${payload.clientId}/changes/`
  );
}

export function getFundBasketLinkedSipCartStatus(payload: {
  basketId: number;
  clientId: number;
}): Promise<FundBasketLinkedSipCartStatus[]> {
  return api.get(
    `fund-baskets/${payload.basketId}/linked-sips/${payload.clientId}/cart-status/`
  );
}

export function rebalanceFundBasketLinkedSips(
  payload: { basketId: number } & FundBasketRebalanceRequest
): Promise<FundBasketRebalanceResponse> {
  const { basketId, ...data } = payload;
  return api.post(`fund-baskets/${basketId}/linked-sips/rebalance/`, data);
}

export function getFundBasketVersions(
  basketId: number
): Promise<FundBasketVersion[]> {
  return api.get(`fund-baskets/${basketId}/versions/`);
}
